import { render, staticRenderFns } from "./Game_UserBuyProducts.vue?vue&type=template&id=dddac054&scoped=true&"
import script from "./Game_UserBuyProducts.vue?vue&type=script&lang=js&"
export * from "./Game_UserBuyProducts.vue?vue&type=script&lang=js&"
import style0 from "./Game_UserBuyProducts.vue?vue&type=style&index=0&id=dddac054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddac054",
  null
  
)

export default component.exports